export const RouterEnum = {
    SignIn: {
        path: '/signin',
        name: 'Signin',
    },
    ResetPwd: {
      path: '/reset-pwd',
      name: 'ResetPwd'
    },
    Dashboard: {
        path: '/dashboard',
        name: 'Dashboard',
    },
    ItemManagement: {
        path: '/item',
        name: 'Item',
        ItemList: {
            path: 'list',
            name: 'ItemList',
        },
        AddItem: {
            path: 'add',
            name: 'AddItem',
        },
        ModifyItem: {
            path: 'modify/:itemId',
            name: 'ModifyItem',
        }
    },
    ProductManagement: {
        path: '/product-list',
        name: 'ProductsList',
    },
    CertificateList: {
        path: '/certificate-list',
        name: 'CertificateListCertificateList',
    },
    CustomerDetails: {
        name: 'CustomerDetails',
        path: '/customer-details',
    },
    Certificate: {
        path: '/certificate',
        name: 'Certificate',
        CertificateList: {
            path: 'list',
            name: 'CertificateCertificateList',
        },
        IssueCertificate: {
            path: 'issue',
            name: 'IssueCertificate',
        },
        CertificateSettings: {
            path: 'settings',
            name: 'CertificateSettings',
        },
    },
    Swift: {
        path: '/swift',
        name: 'Swift',
        SwiftList: {
            path: 'list',
            name: 'SwiftList',
        },
        IssueSwift: {
            path: 'issue',
            name: 'IssueSwift',
        },
        SwiftSettings: {
            path: 'settings',
            name: 'SwiftSettings',
        },
        ModifySwift: {
            path: 'modify/:swiftId',
            name: 'ModifySwift',
        },
    },
    HospitalManagement: {
        path: '/hospital',
        name: 'Hospital',
        HospitalList: {
            path: 'list',
            name: 'HosManage',
        },
        // HospitalAccountManagement: {
        //     path: 'accounts',
        //     name: 'HosAccManage',
        // },
        AddHospital: {
            path: 'add',
            name: 'AddHospital',
        },
        ModifyHospital: {
            path: 'modify/:hospitalId',
            name: 'ModifyHospital',
        },
        ReviewManagement: {
            path: 'reviews',
            name: 'ReviewManagement',
        }
    },
    ContractManagement: {
        path: '/contract',
        name: 'Contract',
        ContractList: {
            path: 'list',
            name: 'ContractList'
        },
        ContractTypeList: {
            path: 'types',
            name: 'ContractTypeList'
        },
        // ⚠️name 값을 https://app.modusign.co.kr/templates 의 이름과 일치 시켜야 함.
        Contracts: {
            Dentium: {
                // 영업
                // 레거시(구 양식) — 라우트는 제거했고, 하위 컴포넌트의 name 참조용으로만 남긴다
                Mulpum: {
                    path: 'sales-contract',
                    name: '덴티움 물품 매매 계약서(구)',
                },
                MulpumPromotion: {
                    path: 'sales-propmotion-contract',
                    name: '매출 프로모션 계약서',
                },
                // V5·V6는 양식(base PDF)만 바뀌고 입력 항목은 동일 → MulpumV6.vue 한 컴포넌트를 공유
                // 현행 양식. 계약서 제목 = 라우트 name 이므로 모두싸인 템플릿 제목과 일치해야 한다
                MulpumV6: {
                    path: 'sales-contract-v6',
                    name: '덴티움 물품 매매 계약서',
                },
                // 장비
                UnitChair: {
                    path: 'unit-chair',
                    name: 'Unit Chair 매매계약서',
                },
                BrightCT: {
                    path: 'bright-ct',
                    name: 'bright CT 매매 계약서',
                },
                CadCam: {
                    path: 'cad-cam',
                    name: 'CAD.CAM 매매계약서',
                },
                Robot: {
                    path: 'robot',
                    name: '서비스 로봇 매매계약서',
                },
                UnitChairV2: {
                    path: 'unit-chair-v2',
                    name: 'UnitChair 매매계약서',
                },
                BrightCTV2: {
                    path: 'bright-ct-v2',
                    name: 'CT 매매계약서',
                },
                CadCamV2: {
                    path: 'cad-cam-v2',
                    name: 'CADCAM 매매계약서',
                },
                ICTMotor: {
                    path: 'ict-motor',
                    name: 'ICT Motor 매매계약서',
                },
                IOX: {
                    path: 'iox',
                    name: 'IOX(W) 매매계약서',
                },
                BrightXray: {
                    path: 'bright-xray',
                    name: 'bright X-ray 매매계약서',
                },
                BNK: {
                    path: 'bnk-purchase',
                    name: 'BNK역구매',
                },
                SINHYUP: {
                    path: 'sinhyup-purchase',
                    name: '신협역구매',
                },
                // 고객지원
                SeolqiChair: {
                    path: 'seolqi-chair',
                    name: 'Chair 제품설치 확인서 수정 (Rev.3)',
                },
                SeolqiCbct: {
                    path: 'seolqi-cbct',
                    name: 'Dentium-CBCT-설치완료 확인서 (Rev.5)',
                },
                // deprecated
                Gongsa: {
                    path: 'construction',
                    name: 'Gongsa',
                },
                Hadogup: {
                    path: 'subcontract-agreement',
                    name: 'Hadogup',
                },
            },
            Plasmapp: {
                ActilinkRental: {
                    path: "actilink-rental",
                    name: "ACTILINK 정기 렌탈서비스 약정서",
                }
            }
        },
        Goal: {
            path: 'goal',
            name: 'GoalManagement'
        },
        // v2 는 v1 과 병존한다. 메뉴 전환은 menus.link 한 필드로 하므로 배포와 분리된다.
        GoalV2: {
            path: 'goal-v2',
            name: 'GoalManagementV2'
        },
    },
    EventManagement: {
        path: '/events',
        name: 'Event',
        EventList: {
            path: 'list',
            name: 'EventList'
        },
        EventDashboard: {
            path: 'dashboard',
            name: 'EventDashboard'
        },
        AddEvent: {
            path: 'add',
            name: 'AddEvent'
        }
    },
    EventManagementV2: {
        path: '/events-v2',
        name: 'EventV2',
        EventList: {
            path: 'list',
            name: 'EventListV2'
        },
        EventStatistics: {
            path: 'statistics',
            name: 'EventStatistics'
        },
        DailyStatistics: {
            path: 'daily-statistics',
            name: 'DailyStatistics'
        },
        StatisticsSummary: {
            path: 'statistics-summary',
            name: 'EventStatisticsSummary'
        },
        AttendeeSegmentRaw: {
            path: 'attendee-segment-raw',
            name: 'AttendeeSegmentRaw'
        },
        EventReport: {
            path: 'report',
            name: 'EventReport'
        }
    },
    SalesRecordManagement: {
        path: '/salesrecords',
        name: 'SalesRecordManagement',
        DentiumErpSalesRecordList: {
            path: 'dentium/erp/list',
            name: 'DentiumErpList'
        },
        DentiumErpGoal: {
            path: 'dentium/erp/goal',
            name: 'DentiumErpGoalManagement'
        },
        SubscriptionList: {
            path: 'subscription/list',
            name: 'SubscriptionList'
        }
    },
    ManufacturerAccounts: {
        path: '/manufacturer-accounts',
        name: 'ManuAccManage',
        ManufacturerAccountsList: {
            path: 'list',
            name: 'ManuAccManage',
        }
    },
    ApiKeyManagement: {
        path: '/api-keys',
        name: 'ApiKeyList',
    },
    CompanyManagement: {
        path: '/info',
        name: 'CompanyInfo',
    },
    NoticeManagement: {
        path: '/notices',
        name: 'Notices',
        NoticeList: {
            path: 'list',
            name: 'NoticesList',
        },
        NoticeDetail: {
            path: ':id',
            name: 'NoticeRead',
        }
    },
    ProductCertificateLink: {
        path: '/product-certificate-link',
        name: 'ProductCertificateLink',
    },
    BrandSettings: {
        path: '/brand-settings',
        name: 'BrandSettings',
        Menu: {
            path: 'menu',
            name: 'BrandSettings',
        },
    },
    GtinManagement: {
        path: '/gtin-management',
        name: 'GtinManagement',
        List: {
            path: 'list',
            name: 'GtinManagementList',
        },
    },
    BrightmallManagement: {
        path: '/brightmall',
        name: 'BrightmallManagement',
        Orders: {
            path: 'orders',
            name: 'BrightmallOrders',
        },
    },
    Promotions: {
        path: '/promotions',
        name: 'Promotions',
        List: {
            path: '',
            name: 'PromotionList',
        },
        Create: {
            path: 'create',
            name: 'PromotionCreate',
        },
        Edit: {
            path: ':promotionId/edit',
            name: 'PromotionEdit',
        },
        Detail: {
            path: ':promotionId',
            name: 'PromotionDetail',
        },
        Entries: {
            path: ':promotionId/entries',
            name: 'PromotionEntries',
        },
        EntryDetail: {
            path: ':promotionId/entries/:entryId',
            name: 'PromotionEntryDetail',
        },
    },
    Alimtalk: {
        path: '/alimtalk',
        name: 'Alimtalk',
        ChannelSettings: {
            path: 'channel',
            name: 'AlimtalkChannelSettings',
        },
        TemplateList: {
            path: 'template/list',
            name: 'AlimtalkTemplateList',
        },
        TemplateCreate: {
            path: 'template/create',
            name: 'AlimtalkTemplateCreate',
        },
        TemplateEdit: {
            path: 'template/edit/:channelId/:templateCode',
            name: 'AlimtalkTemplateEdit',
        },
        TemplateBulkCreate: {
            path: 'template/bulk-create',
            name: 'AlimtalkTemplateBulkCreate',
        },
    },
    // 모바일에서 막은 갈래로 들어왔을 때 보여 주는 안내 화면
    MobileBlocked: {
        path: '/mobile-blocked',
        name: 'MobileBlocked',
    },
    // 폰 하단 탭 맨 오른쪽에 항상 있는 화면. 폰에서 로그아웃하는 유일한 경로다.
    MyPage: {
        path: '/my-page',
        name: 'MyPage',
    },
    /*
     * 폰에서 '/' 로 들어왔을 때 첫 탭을 정하는 경유 화면.
     *
     * 앱이 여는 주소가 '/' 인데(EndPoint.webViewUrl), 그 라우트는 대시보드로
     * 리다이렉트한다. 그러면 대시보드를 하단 탭에 넣지 않은 제조사도
     * 앱을 켤 때마다 대시보드를 보게 된다.
     *
     * 첫 탭은 서버에서 탭 구성과 권한을 받아야 알 수 있는데, 콜드 스타트 시점에는
     * store 가 비어 있어 라우트 정의에서 정할 수 없다. 그래서 이 화면이 받아 온 뒤
     * replace 로 넘긴다. 사용자에게는 스피너만 잠깐 보인다.
     */
    MobileLanding: {
        path: '/landing',
        name: 'MobileLanding',
    },
    ProductQrManagement: {
        path: '/product-qr',
        name: 'ProductQrManagement',
    },
    // 제품 코드 관리 (PC) — 제조사가 기기를 대량으로 등록·정리하는 정식 화면이다.
    // 사이드바 노출은 「정품 인증 > 제품 코드 관리」 메뉴 등록으로 결정된다(코드가 아니다).
    // 권한 판정은 메뉴명이 아니라 이 path(/product-device)로 한다 — 메뉴명은 운영에서 바뀐다.
    // 「정품 라벨 등록」(/product-label)과 같은 데이터를 다루고 서버 API 도 공유하지만,
    // 이쪽은 PC 대량 작업용이라 화면 체계가 다르다. 모바일에서는 사이드바에 뜨지 않는다.
    ProductDeviceManagement: {
        path: '/product-device',
        name: 'ProductDeviceManagement',
    },
    // 정품 라벨 등록 — 영업사원이 현장에서 기기에 라벨을 붙여 등록한다 (모바일 기준).
    // 기획서 [써마지] 영업사원 정품 인증 코드 등록(2026-07-07) 화면 ②~⑩.
    // 같은 데이터를 다루지만 화면 체계가 달라 ProductDeviceManagement 와 라우트를 나눈다.
    ProductLabel: {
        path: '/product-label',
        name: 'ProductLabel',
        // ② 기기 목록
        List: {
            path: 'list',
            name: 'ProductLabelList',
        },
        // ③④⑤⑥⑦ 신규 등록 3단계
        Register: {
            path: 'register',
            name: 'ProductLabelRegister',
        },
        // 임시 저장 처리 — 임시저장 건만 모아 보고 바로 채우러 들어간다 (시안 scr-pending)
        // 목록의 배너에서 들어온다. 「:deviceId」 보다 먼저 선언해야 한다 —
        // 뒤에 두면 'pending' 이 deviceId 로 잡혀 상세로 들어간다.
        Pending: {
            path: 'pending',
            name: 'ProductLabelPending',
        },
        // ⑧ 기기 상세 (→ ⑨ 정보 수정 · ⑩ 라벨 QR 재등록)
        Detail: {
            path: ':deviceId',
            name: 'ProductLabelDetail',
        },
        // 변경 이력 — 상세에서 갈라져 나온 전용 화면 (시안 scr-history)
        // 지켜야 할 입력 상태가 없어 패널이 아니라 라우트로 둔다. 뒤로가기가 자연스럽다.
        History: {
            path: ':deviceId/history',
            name: 'ProductLabelHistory',
        },
        // ⑨ 정보 수정
        Edit: {
            path: ':deviceId/edit',
            name: 'ProductLabelEdit',
        },
        // ⑩ 라벨 QR 재등록 (라벨 훼손)
        QrReassign: {
            path: ':deviceId/qr',
            name: 'ProductLabelQrReassign',
        },
    },
}
